
import { Fade, FadeProps } from '@mui/material';
import React from 'react';

const FadeWrapper: React.ForwardRefExoticComponent<Omit<FadeProps, 'ref'> & React.RefAttributes<HTMLElement>> =
    React.forwardRef<HTMLElement, FadeProps>((props, ref) => <Fade {...props} ref={ref} />)

export default FadeWrapper;
